"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.allTimeUnits = exports.day = exports.hour = exports.minute = exports.second = exports.millisecond = exports.allMassUnits = exports.kilogram = exports.gram = exports.milligram = exports.allLengthUnits = exports.kilometer = exports.meter = exports.centimeter = exports.millimeter = void 0;
const date_fns_1 = require("date-fns");
// Supported length units.
exports.millimeter = {
    type: "Length",
    symbol: "mm",
    multiplier: -1000,
};
exports.centimeter = {
    type: "Length",
    symbol: "cm",
    multiplier: -100,
};
exports.meter = {
    type: "Length",
    symbol: "m",
    multiplier: 1,
};
exports.kilometer = {
    type: "Length",
    symbol: "km",
    multiplier: 1000,
};
exports.allLengthUnits = [
    exports.kilometer,
    exports.meter,
    exports.centimeter,
    exports.millimeter,
];
// Supported mass units.
exports.milligram = {
    type: "Mass",
    symbol: "mg",
    multiplier: -1000000,
};
exports.gram = {
    type: "Mass",
    symbol: "g",
    multiplier: -1000,
};
exports.kilogram = {
    type: "Mass",
    symbol: "kg",
    multiplier: 1,
};
exports.allMassUnits = [
    exports.kilogram,
    exports.gram,
    exports.milligram,
];
// Supported time units.
exports.millisecond = {
    type: "Time",
    symbol: "ms",
    multiplier: -1000,
};
exports.second = {
    type: "Time",
    symbol: "s",
    multiplier: 1,
};
exports.minute = {
    type: "Time",
    symbol: "min",
    multiplier: date_fns_1.secondsInMinute,
};
exports.hour = {
    type: "Time",
    symbol: "h",
    multiplier: date_fns_1.secondsInHour,
};
exports.day = {
    type: "Time",
    symbol: "d",
    multiplier: date_fns_1.secondsInDay,
};
exports.allTimeUnits = [
    exports.day,
    exports.hour,
    exports.minute,
    exports.second,
    exports.millisecond,
];
